import * as PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import Label from '../Label';
import styles from './LabeledContainer.module.scss';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const cln = classnames.bind(styles);
function LabeledContainer({
  className,
  strict = false,
  horizontalLabelSpace = 'big',
  labelContainerWidth,
  // eslint-disable-line
  label = '',
  labelWidth,
  children,
  width,
  variant = 'vertical',
  ...rest
}) {
  const classes = cln('LabeledContainer', `LabeledContainer--${variant}`, className);
  const css = {};
  if (variant === 'horizontal' && (labelWidth || width)) {
    const col1 = labelWidth ? `${labelWidth}px` : 'max-content';
    const col2 = width ? `${width}px` : 'auto';
    css.gridTemplateColumns = `${col1} ${col2}`;
  } else if (width) {
    css.gridTemplateColumns = `minmax(auto,${width}px)`;
  }
  const Container = strict ? 'label' : 'div';
  return /*#__PURE__*/_jsxs(Container, {
    style: css,
    className: classes,
    ...rest,
    children: [/*#__PURE__*/_jsx(Label, {
      className: cln('Label', {
        [`Label--${horizontalLabelSpace}`]: horizontalLabelSpace
      }),
      children: label
    }), children]
  });
}
LabeledContainer.propTypes = {
  /** Anything you want to be displayed on the input level row. Usually you will pass here Buttons or
   * anything what has similar or the same height/size as the input field */
  children: PropTypes.node.isRequired,
  /** Label which will be displayed above the input field */
  label: PropTypes.node,
  /** Vertical variant renders label on top, horizontal renders label on the left */
  variant: PropTypes.oneOf(['horizontal', 'vertical']),
  /** Custom class name set on the children container */
  className: PropTypes.string,
  /** Width of the input filed in px. Keep in mind that this will apply an inline style. */
  width: PropTypes.number,
  /** Width of the label container (applied only with horizontal variant) */
  labelWidth: PropTypes.number,
  /** When true, container becomes label tag, div otherwise */
  strict: PropTypes.bool,
  /** Defines horizontal space of the label (applied only with horizontal variant) */
  horizontalLabelSpace: PropTypes.oneOf(['big', 'small', 'compact']),
  /** Label container width (applied only with horizontal variant) */
  labelContainerWidth: PropTypes.number
};
export default LabeledContainer;